<template>
  <el-form>
    <el-form-item class="search-container">
      <el-autocomplete
        v-model="searchQuery"
        :fetch-suggestions="querySearch"
        :placeholder="label"
        :trigger-on-focus="false"
        @select="handleSelect"
        @blur="showSuggestions = false"
        popper-class="mobile-suggestions"
        class="search-input"
      >
        <!-- 搜索图标 -->

        <!-- 提交按钮 -->
        <template #suffix>
          <el-button
            native-type="submit"
            :loading="isSubmitting"
            :icon="isSubmitting ? '' : 'Search'"
            class="submit-button"
            @click="handleSubmit"
          >
            {{ submitText }}
          </el-button>
        </template>
      </el-autocomplete>
    </el-form-item>

    <!-- 新增日期选择框 -->
    <el-form-item class="date-picker-container">
      <el-date-picker
        v-model="selectedDate"
        type="date"
        :placeholder="datePlaceholder"
        :clearable="false"
        format="YYYY-MM-DD"
        value-format="YYYY-MM-DD"
        @change="handleDateChange"
        class="date-picker"
      />
    </el-form-item>
  </el-form>
</template>
<script>
import axios from 'axios';
import debounce from 'lodash-es/debounce';

export default {
  props: {
    isSubmitting: Boolean,
    label: {
      type: String,
      default: '股票名称或代码',
    },
    submitText: {
      type: String,
      default: '查询',
    },
    // 新增日期选择框的占位符属性
    datePlaceholder: {
      type: String,
      default: '请选择日期'
    }
  },
  data() {
    // 设置默认日期为当前日期
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    return {
      searchQuery: '',
      showSuggestions: false,
      // 新增日期数据，默认值设为当前日期
      selectedDate: formattedDate
    };
  },
  computed: {
    // 新增计算属性：判断是否为晚上9点
    showNightTip() {
      const now = new Date();
      const hours = now.getHours();
      // 晚上9点（21点）显示提示
      return hours === 21;
    }
  },
  created() {
    this.debouncedFetch = debounce((query, cb) => {
      this.querySearchAsync(query, cb);
    }, 300);
  },
  beforeUnmount() {
    if (this.debouncedFetch && this.debouncedFetch.cancel) {
      this.debouncedFetch.cancel();
    }
  },
  methods: {
    async querySearchAsync(query, cb) {
      if (query.length < 1) return cb([]);
      try {
        const { data } = await axios.get('/api/stock_list', { params: { query } });
        cb(data.map(item => ({ value: item })));
      } catch (error) {
        console.error('获取建议失败:', error);
        cb([]);
      }
    },
    querySearch(query, cb) {
      if (query.length < 1) return cb([]);
      this.debouncedFetch(query, cb);
    },
    handleSelect(item) {
      this.searchQuery = item.value;
      this.$emit('select', item.value);
    },
    handleSubmit() {
      // 发送事件时同时传递搜索词和选中的日期
      this.$emit('submit', {
        query: this.searchQuery,
        date: this.selectedDate
      });
    },
    // 处理日期变化事件
    handleDateChange(date) {
      this.selectedDate = date;
      this.$emit('date-change', date);
    }
  },
};
</script>


<style scoped>
/* 整体容器 */
.mobile-search-form {
  padding: 12px;
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 24px;
}

/* 输入框样式 */
:deep(.el-input__wrapper) {
  border-radius: 24px;
  padding: 0 0 0 15px;
  background-color: #f8f9fa;
  border: none;
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

:deep(.el-input__inner) {
  font-size: 16px;
  color: #333333;
  height: 48px;
  line-height: 48px;
}

:deep(.el-input__inner:focus) {
  background-color: #ffffff;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 搜索图标 */
.search-icon {
  font-size: 20px;
  color: #999999;
  cursor: pointer;
  transition: color 0.3s ease;
}

.search-icon:hover {
  color: #409eff;
}

/* 提交按钮 */
.submit-button {
  border-radius: 24px;
  padding: 8px 20px;
  height: 48px;
  background-color: #409eff;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  border: none;
  transition: all 0.3s ease;
}

.submit-button:hover {
  background-color: #66b1ff;
}

.submit-button:active {
  background-color: #3a8ee6;
}

/* 建议列表样式 */
:deep(.mobile-suggestions) {
  width: 100% !important;
  max-height: 60vh;
  overflow-y: auto;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

:deep(.el-autocomplete__popper-item) {
  padding: 12px 16px;
  font-size: 14px;
  color: #333333;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}

:deep(.el-autocomplete__popper-item:hover) {
  background-color: #f0f7ff;
}

/* 日期选择器样式 */
.date-picker-container {
  margin-top: 12px;
}

:deep(.date-picker) {
  width: 100%;
}

:deep(.el-date-editor.el-input__wrapper) {
  border-radius: 24px;
  padding: 0 15px;
  background-color: #f8f9fa;
  border: none;
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

:deep(.el-date-editor.el-input__wrapper:hover) {
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 移动端优化 */
@media (max-width: 768px) {
  .mobile-search-form {
    padding: 8px;
  }

  :deep(.el-input__inner) {
    font-size: 14px;
    height: 44px;
  }

  .submit-button {
    padding: 6px 16px;
    font-size: 14px;
  }

  .date-picker-container {
    margin-top: 8px;
  }
}
</style>
